import axios from "../customize_axios";

export const getHotBooks = async () => {
    try {
        const response = await axios.get('/api/books/hot-books');
        return response.data;
    } 
    catch (error) {
        console.error(error);
        return [];
    }
};

export const getBestSellerBooks = async () => {
    try {
        const response = await axios.get('/api/books/sale-books');
        return response.data;
    } 
    catch (error) {
        console.error(error);
        return [];
    }
};

export const getBookByID = async (bookID) => {
    try {
        const response = await axios.get(`/api/books/${bookID}`)
        return response.data
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const getCategories = async () => {
    try {
      const response = await axios.get('/api/categories');
      return response.data; 
    }
    catch (error) {
        console.error(error);
        return [];
    }
};

export const getBookByCategoryID = async (categoryID, params, filters) => {
    try {
        // const response = await axios.get(`/api/books/category/${categoryID}?page=${page}`)
        const response = await axios.post(`/api/books/category/${categoryID}`, 
            filters,
            {
                params: params,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        return response.data
    } catch (error) {
        console.log("getBookByCategoryID", error.response ? error.response.data : error.message)
        return []
    }
}

export const getAllBooks = async (params, filters) => {
    try {
        // const response = await axios.get(`/api/books?page=${page}`)
        const response = await axios.post(`/api/books`, 
            filters,
            {
                params: params,
                headers: {
                    "Content-Type": "application/json"
                }
            }

        )
        return response.data
    } catch (error) {
        console.log("getAllBooks", error.response ? error.response.data : error.message)
        return []
    }
}

export const getBookRandomByCategory = async (categoryID) => {
    try {
        const response = await axios.get(`/api/books/same-category/${categoryID}`)
        return response.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const getTargets = async () => {
    try {
        const response = await axios.get('/api/targets')
        return response.data
    } catch (error) {
        console.log(error)
        return []
    }
}

export const getBookByAuthorID = async (authorID, page) => {
    try {
        const response = await axios.get(`/api/books/author/${authorID}?page=${page}`)
        return response.data
    } catch (error) {
        console.log("getBookByAuthorID", error.response ? error.response.data : error.message)
        return []
    }
}

export const getBookBySearch = async (searchText, page) => {
    try {
        const response = await axios.get(`api/books/search/${searchText}/result?page=${page}`)
        return response.data
    } 
    catch (error) {
        console.log("getBookBySearch: ", error.response ? error.response.data : error.message)
        return []
    }
}

export const getHighestPrice = async () => {
    try {
        const response = await axios.get("api/books/highest-price")
        return response.data
    } 
    catch (error) {
        console.error("getHighestPrice", error.response ? error.response.data : error.message);
    }
}

export const getBestRatingBook = async () => {
    try {
        const response = await axios.get("api/books/top-rating")
        return response.data
    } 
    catch (error) {
        console.error("getBestRatingBook", error.response ? error.response.data : error.message);
    }
}





